import { Contract } from 'ethers';
import { ContractLoader } from '../../helpers/ContractLoader';

const artifacts = {
  _format: 'hh-sol-artifact-1',
  contractName: 'LPToken',
  sourceName: 'contracts/LPToken.sol',
  abi: [
    {
      inputs: [
        {
          internalType: 'string',
          name: 'name',
          type: 'string',
        },
        {
          internalType: 'string',
          name: 'symbol',
          type: 'string',
        },
        {
          internalType: 'address',
          name: '_token0',
          type: 'address',
        },
        {
          internalType: 'address',
          name: '_token1',
          type: 'address',
        },
        {
          internalType: 'uint24',
          name: '_fee',
          type: 'uint24',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'constructor',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'spender',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'value',
          type: 'uint256',
        },
      ],
      name: 'Approval',
      type: 'event',
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          indexed: true,
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          indexed: false,
          internalType: 'uint256',
          name: 'value',
          type: 'uint256',
        },
      ],
      name: 'Transfer',
      type: 'event',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'owner',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'spender',
          type: 'address',
        },
      ],
      name: 'allowance',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'spender',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'approve',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'account',
          type: 'address',
        },
      ],
      name: 'balanceOf',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'burn',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'decimals',
      outputs: [
        {
          internalType: 'uint8',
          name: '',
          type: 'uint8',
        },
      ],
      stateMutability: 'pure',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'spender',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'subtractedValue',
          type: 'uint256',
        },
      ],
      name: 'decreaseAllowance',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'fee',
      outputs: [
        {
          internalType: 'uint24',
          name: '',
          type: 'uint24',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'spender',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'addedValue',
          type: 'uint256',
        },
      ],
      name: 'increaseAllowance',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'mint',
      outputs: [],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [],
      name: 'name',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'symbol',
      outputs: [
        {
          internalType: 'string',
          name: '',
          type: 'string',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'token0',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'token1',
      outputs: [
        {
          internalType: 'address',
          name: '',
          type: 'address',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [],
      name: 'totalSupply',
      outputs: [
        {
          internalType: 'uint256',
          name: '',
          type: 'uint256',
        },
      ],
      stateMutability: 'view',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'transfer',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
    {
      inputs: [
        {
          internalType: 'address',
          name: 'from',
          type: 'address',
        },
        {
          internalType: 'address',
          name: 'to',
          type: 'address',
        },
        {
          internalType: 'uint256',
          name: 'amount',
          type: 'uint256',
        },
      ],
      name: 'transferFrom',
      outputs: [
        {
          internalType: 'bool',
          name: '',
          type: 'bool',
        },
      ],
      stateMutability: 'nonpayable',
      type: 'function',
    },
  ],
  bytecode:
    '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',
  deployedBytecode:
    '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',
  linkReferences: {},
  deployedLinkReferences: {},
};

export class UniswapV3 {
  contract: Contract | null;
  loader: ContractLoader;

  constructor() {
    this.loader = new ContractLoader({
      name: 'UniswapV3',
      bytecode: artifacts.bytecode,
      abi: artifacts.abi,
    });

    this.contract = null;
  }

  async load(address: string): Promise<void> {
    this.contract = await this.loader.load(address);
  }

  async getReserves(): Promise<string[]> {
    if (this.contract === null) throw new Error('Trying to use unloaded contract');

    return ['1', '1'];
  }

  async getTokens(): Promise<string[]> {
    if (this.contract === null) throw new Error('Trying to use unloaded contract');

    return [await this.contract.token0(), await this.contract.token1()];
  }

  async getTotalSupply(): Promise<string> {
    if (this.contract === null) throw new Error('Trying to use unloaded contract');

    return await this.contract.totalSupply();
  }
}
